export const TIRE_SET_PDF_COLUMNS = [
  'setNumber',
  'branch',
  'storageWarehouse',
  'storageLocation',
  'wheelNumber',
  'setStoreUntil',
  'vehicle',
  'vehicleRegistrationPlate',
  'vehicleVin',
  'contactPersonName',
  'contactPersonPhone',
  'tireCategory',
  'tireWheel',
  'tireSeason',
  'dot',
  'requestType',
  'requestState',
  'neededAt',
  'requestHomeBranch',
  'requestDestinationBranch',
] as const;
